import { TEN, ZERO } from '@constants';
import { ErrorDescription } from '@customTypes';

export const getTranslatedErrorMessage = (
  errorDescription: ErrorDescription | string,
  getTranslation: (key1: string, key2?: string) => string,
) => {
  if (typeof errorDescription === 'string') {
    return errorDescription;
  }

  const { key, values } = errorDescription;
  const translation = getTranslation(key);

  if (!values?.length) return translation;

  return translation.replace(/\{\{\s*(\d+)\s*\}\}/g, (match: string, indexStr: string) => {
    const index = parseInt(indexStr, TEN);

    return index >= ZERO && index < values.length ? values[index] : match;
  });
};
